module.exports = __webpack_public_path__ + "static/media/Logo-Bank-Mandiri.cd024a06.png";